import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AUTH_PUBLIC_APP_ROUTES } from "../store/authConfig";
import { selectIsAuthenticated } from "../store/authSelectors";

const AuthWatcher = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      !isAuthenticated &&
      !AUTH_PUBLIC_APP_ROUTES.includes(location.pathname)
    ) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate, location.pathname]);

  return null;
};

export default AuthWatcher;
